var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('az-loading'),_c('div',{staticClass:"alert alert-info text-center mt-3"},[_vm._v(_vm._s(this.path))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }